"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const basic_form_input_1 = __importDefault(require("../../../client/form_components/inputs/basic_form_input"));
const base_1 = __importDefault(require("../../../client/buttons/base"));
const Loader_1 = __importDefault(require("../../../client/reusable_components/Router/Loader"));
const dispatchers_1 = require("../../../utility/dispatchers");
const error_handler_1 = __importDefault(require("../../../services/error_handler"));
const graphql_1 = require("../../../requests/graphql");
const validators_1 = require("../../../services/validation/validators");
const types_1 = require("../../../utility/types");
const layout_css_1 = __importDefault(require("../../../styles/global_ui/layout.css"));
const typography_css_1 = __importDefault(require("../../../styles/global_ui/typography.css"));
const c = {
    form: `${layout_css_1.default.fullWidth}`,
    h2: `${typography_css_1.default.h3Responsive} ${typography_css_1.default.fontWeightNormal} ${layout_css_1.default.marginTop0} ${layout_css_1.default.marginBottom30}`,
    buttons: `${layout_css_1.default.flexJustifyEnd} ${layout_css_1.default.paddingTop30} ${layout_css_1.default.gutter15}`,
};
const NewGiveawayForm = ({ setShowForm }) => {
    const [errors, setErrors] = (0, react_1.useState)({});
    const [form, setForm] = (0, react_1.useState)();
    const [isSubmitting, setIsSubmitting] = (0, react_1.useState)(false);
    const validateFields = (0, react_1.useCallback)(() => {
        const formErrors = [
            { name: 'title', value: form.title, validFn: (val) => (0, validators_1.isRequired)(val) },
            { name: 'slug', value: form.slug, validFn: (val) => (0, validators_1.isRequired)(val) || (0, validators_1.isValidSlug)(val) },
        ].reduce((acc, { name, value, validFn }) => {
            const res = validFn(value);
            if (res)
                acc[name] = res;
            return acc;
        }, {});
        setErrors(formErrors);
        return !(0, types_1.isBlank)(formErrors);
    }, [form]);
    const handleUpdate = (0, react_1.useCallback)(({ name, value }) => {
        setForm({ ...form, [name]: value.trim() });
    }, [form]);
    const handleSubmit = (0, react_1.useCallback)((e) => {
        e.preventDefault();
        const hasErrors = validateFields();
        if (hasErrors)
            return;
        setIsSubmitting(true);
        return (0, graphql_1.graphMutate)({ t: 'create_giveaway' }, form)
            .then(({ giveaway }) => {
            const url = `giveaways/${giveaway.id}/edit`;
            window.location.href = url;
        })
            .catch((err) => {
            (0, dispatchers_1.summonGlobalMessenger)({
                msg: JSON.parse(err.response.text).errors[0],
                type: 'error',
            });
            (0, error_handler_1.default)('Giveaway Dashboard handleSubmit Error: ', err);
            setIsSubmitting(false);
        });
    }, [form, validateFields]);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("h2", { className: c.h2 }, "Create a new Giveaway"),
        isSubmitting
            ? react_1.default.createElement(Loader_1.default, null)
            : (react_1.default.createElement("form", { className: c.form, onSubmit: handleSubmit },
                react_1.default.createElement(basic_form_input_1.default, { disabled: isSubmitting, errors: errors?.title, label: "Title", name: "title", onBlur: ({ target: { value } }) => handleUpdate({ name: 'title', value }), placeholder: "Epic AI Giveaway" }),
                react_1.default.createElement(basic_form_input_1.default, { disabled: isSubmitting, errors: errors?.slug, helperText: "This is the trailing portion of the url", label: "Slug", name: "slug", onBlur: ({ target: { value } }) => handleUpdate({ name: 'slug', value }), placeholder: "Epic-AI-Giveaway-2025" }),
                react_1.default.createElement("div", { className: c.buttons },
                    react_1.default.createElement(base_1.default, { onClick: () => setShowForm(false), size: "md", type: "button" }, "Cancel"),
                    react_1.default.createElement(base_1.default, { disabled: isSubmitting, onClick: handleSubmit, size: "md", type: "submit" }, "Submit"))))));
};
exports.default = NewGiveawayForm;
